export const customFieldTypes = Object.freeze({
  TEXT: 'TEXT',
  LIST: 'LIST',
  NUMERIC: 'NUMERIC',
  DATE: 'DATE',
  CURRENCY: 'CURRENCY',
  HOUR: 'HOUR',
  TELEPHONE: 'TELEPHONE',
  CPF: 'CPF',
  CNPJ: 'CNPJ',
  MULTIPLE: 'MULTIPLE',
  LINK: 'LINK'
});
